<template>
  <div>
    <div
      v-if="handlesTooltip()"
      class="is-flex"
      v-tooltip.right="{
        content: `<div class='has-text-centered' style='width: 100%;'>        
          <h1 class='has-text-centered has-text-weight-bold'>Variación</h1>
          <span class='is-5' style='width: 100%'>
          ${nameRange.length ? getVariant() : '-'}
          </span>
          <h1 class='has-text-centered has-text-weight-bold'>Anterior</h1>
          <span class='is-5' style='width: 100%'>
            ${nameRange.length ? nameRange : 'Sin comparación'} 
            ${nameRange.length ? `${percentage.toFixed(2)}%` : ''}
          </span>
        </div>`,
      }"
      v-html="upOrDown()"
    ></div>
    <div v-if="!handlesTooltip()" class="is-flex" v-html="upOrDown()"></div>
  </div>
</template>
<script>
const up = (w, h) => `<svg
    xmlns="http://www.w3.org/2000/svg"
    width='${w}' height='${h}'
    style='margin-right: 15px; padding: 2px; background-color: #ffffff7a; border-radius: 5px'
    viewBox="0 0 24 24"
  >
  <path
    fill="#0cc100"
    d="M3 19h18a1.002 1.002 0 0 0 .823-1.569l-9-13c-.373-.539-1.271-.539-1.645 0l-9 13A.999.999 0 0 0 3 19"
  />  
  </svg>`;

const down = (w, h) => `<svg
    xmlns="http://www.w3.org/2000/svg"
    width='${w}' height='${h}'
    style='margin-right: 15px; padding: 2px; background-color: #ffffff7a; border-radius: 5px'
    viewBox="0 0 24 24"
  >
  <path
    fill="#c10000"
    d="M11.178 19.569a.998.998 0 0 0 1.644 0l9-13A.999.999 0 0 0 21 5H3a1.002 1.002 0 0 0-.822 1.569z"
  />
  </svg>`;

const stable = (w, h) => `<svg
    xmlns="http://www.w3.org/2000/svg"
    width="${w}" height="${h}"
    style='margin-right: 15px'
    viewBox="0 0 16 16" 
    >

  </svg>`;
/* const stable = (w, h) => `<svg
    xmlns="http://www.w3.org/2000/svg"
    width="${w}" height="${h}"
    style='margin-right: 15px'
    viewBox="0 0 100 100"  
    >
    <path fill="currentColor" d="M80.049 22.127a2.16 2.16 0 0 0-2.163-2.156c-.028 0-.054.007-.082.008H22.302c-.063-.006-.125-.019-.19-.019a2.163 2.163 0 0 0-2.163 2.163c0 .101.016.198.03.295V77.87h.001l-.001.009c0 1.194.969 2.162 2.163 2.162c.046 0 .089-.011.134-.013v.002h55.688v-.018a2.16 2.16 0 0 0 2.084-2.142h.001z"/>
  </svg>`; */

export default {
  data() {
    return {
      range: 0,
      nameRange: "",
      percentage: 0,
      tpM: true,
    };
  },
  props: {
    summary: {
      type: Object,
      required: true,
    },
    group: {
      type: String,
      required: true,
    },
    nombrerangos: {
      type: Object,
      required: true,
    },
    rangos: {
      type: Function,
    },
    w: {
      type: Number,
      default() {
        return 30;
      },
    },
    h: {
      type: Number,
      default() {
        return 30;
      },
    },
    tooltip: {
      type: Boolean,
      default() {
        return true;
      },
    },
  },
  methods: {
    upOrDown() {
      const group = this.group;
      const percentage =
        ((this.summary.total[group].p -
          this.summary.processComp.total[group].p) /
          this.summary.processComp.total[group].p) *
        100;
      if (percentage >= 10) {
        return up(this.w, this.h);
      } else if (percentage <= -10) {
        return down(this.w, this.h);
      } else {
        // this.tpM = false;
        return stable(this.w, this.h);
      }
    },
    getVariant() {
      const group = this.group;
      const percentage =
        ((this.summary.total[group].p -
          this.summary.processComp.total[group].p) /
          this.summary.processComp.total[group].p) *
        100;
      if (percentage >= 10) {
        return "Mejoró";
      } else if (percentage <= -10) {
        return "Desmejoró";
      } else {
        return "Sin cambio significativo";
      }
    },
    calculate() {
      const group = this.group;
      if (
        this.summary.processComp &&
        !isNaN(this.summary.processComp.total[group].p)
      ) {
        this.range = this.rangos(
          this.summary.processComp.total
            ? this.summary.processComp.total[group].p
            : 0
        );
        this.nameRange = this.nombrerangos[this.range];
        this.percentage = this.summary.processComp.total
          ? this.summary.processComp.total[group].p
          : 0;
      } else {
        this.range = 0;
        this.nameRange = "";
        this.percentage = 0;
      }
    },
    handlesTooltip() {
      if (!this.tpM) {
        return false;
      }
      return this.tooltip;
    },
  },
  created() {
    this.calculate();
  },
  watch: {
    summary() {
      this.calculate();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/climan/components/directionIndicator.vue